import $ from 'jquery';
// import mpro from './mpro.init';

/**
 * @typedef {string} MpLangvarData
 * @typedef {{ [key: string]: string }} MpReplacements
 */

/** @type {MpLangvarData|false} */
let translationData;

/**
 * Get translation data from dom
 */
const getLangvars = () => {

	if (typeof translationData === 'undefined') {

		const { lang_selector, report_lang_errors } = mpro.config.ui;

		try {
			translationData = JSON.parse($(lang_selector).text());
		}
		catch {
			if (report_lang_errors) {
				console.warn('No translation data could be obtained from DOM using selector: %o', lang_selector);
			}
			// Set to false so we don't look again
			// translationData = false;
		}
	}

	return translationData;
};

/**
 * @param {string} id
 * @param {MpReplacements?} replacements
 */
mpro.langvar = (id, replacements = {}, showWarning = undefined) => {

	/** @type {MpLangvarData} */
	const content = getLangvars()?.[id] || '';

	if (!content) {
		if (showWarning == null) {
			showWarning = mpro.config.ui.report_lang_errors;
		}
		showWarning && console.warn('Translation var (%o) not found in: %o', id, translationData);
		return `{${id}}`;
	}

	return content.replaceAll(/\{\{?\s*([a-z]{1}[\w\.\|]+)\s*\}\}?/igu, (_match, replacer) => {
		return (typeof replacements[replacer] !== 'undefined') ? replacements[replacer] : `{{ ${replacer} }}`;
	});
};

export default mpro;
